export function setPageTitle(title: string) {
  document.title = title;
}

export function setMetaDescription(description: string) {
  let metaTag = document.head.querySelector('meta[name=description]');
  if (!metaTag) {
    metaTag = document.createElement('meta');
    metaTag.setAttribute('name', 'description');
    document.head.appendChild(metaTag);
  }
  metaTag.setAttribute('content', description);
}
